import { Route } from 'react-router-dom'
import ProfileMiddleware from '../middlewares/ProfileMiddleware'

import PageSettings from '../pages/tabs/Settings/PageSettings'
import PageSettingsProfile from '../pages/tabs/Settings/PageSettingsProfile'
import PageSettingsTheme from '../pages/tabs/Settings/PageSettingsTheme'
import PageSettingsAppearance from '../pages/tabs/Settings/PageSettingsAppearance'
import PageSettingsNotifications from '../pages/tabs/Settings/PageSettingsNotifications'
import PageSettingsDevices from '../pages/tabs/Settings/PageSettingsDevices'
import PageSettingsPrivacy from '../pages/tabs/Settings/PageSettingsPrivacy'
import PageSettingsFAQ from '../pages/tabs/Settings/PageSettingsFAQ'
import PageSettingsContact from '../pages/tabs/Settings/PageSettingsContact'
import PageSettingsProfilePassword from '../pages/tabs/Settings/PageSettingsProfilePassword'
import PageSettingsProfileDelete from '../pages/tabs/Settings/PageSettingsProfileDelete'

export const RoutesProfileSettings = [
    <Route
        path="/settings"
        element={
            <ProfileMiddleware>
                <PageSettings />
            </ProfileMiddleware>
        }
        key="route-u-settings"
    />,
    <Route
        path="/settings/profile"
        element={
            <ProfileMiddleware>
                <PageSettingsProfile />
            </ProfileMiddleware>
        }
        key="route-u-settings-profile"
    />,
    <Route
        path="/settings/profile/password"
        element={
            <ProfileMiddleware>
                <PageSettingsProfilePassword />
            </ProfileMiddleware>
        }
        key="route-u-settings-profile-password"
    />,
    <Route
        path="/settings/profile/delete"
        element={
            <ProfileMiddleware>
                <PageSettingsProfileDelete />
            </ProfileMiddleware>
        }
        key="route-u-settings-profile-delete"
    />,
    <Route
        path="/settings/theme"
        element={
            <ProfileMiddleware>
                <PageSettingsTheme />
            </ProfileMiddleware>
        }
        key="route-u-settings-theme"
    />,
    <Route
        path="/settings/appearance"
        element={
            <ProfileMiddleware>
                <PageSettingsAppearance />
            </ProfileMiddleware>
        }
        key="route-u-settings-appearance"
    />,
    <Route
        path="/settings/notifications"
        element={
            <ProfileMiddleware>
                <PageSettingsNotifications />
            </ProfileMiddleware>
        }
        key="route-u-settings-notifications"
    />,
    <Route
        path="/settings/devices"
        element={
            <ProfileMiddleware>
                <PageSettingsDevices />
            </ProfileMiddleware>
        }
        key="route-u-settings-devices"
    />,
    <Route
        path="/settings/privacy"
        element={
            <ProfileMiddleware>
                <PageSettingsPrivacy />
            </ProfileMiddleware>
        }
        key="route-u-settings-privacy"
    />,
    <Route
        path="/settings/faq"
        element={
            <ProfileMiddleware>
                <PageSettingsFAQ />
            </ProfileMiddleware>
        }
        key="route-u-settings-faq"
    />,
    <Route
        path="/settings/contact"
        element={
            <ProfileMiddleware>
                <PageSettingsContact />
            </ProfileMiddleware>
        }
        key="route-u-settings-contact"
    />,
]
